const config = {
//    base_url: process.env.NODE_ENV==="production"?process.env.REACT_APP_BASE_URL:'http://172.16.1.157:9000',
     base_url:process.env.REACT_APP_BASE_URL,
};

export default config;
